const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/$lang/$family/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/$lang/$family/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildFeaturePageLandingHead } from "@/features/feature-page-landing/feature-page-landing-head";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/$lang/$family/")({
  loaderDeps: () => ({}),
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match,
    loaderData
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const family = loaderData?.family;
    if (!family) return {};
    const t = createTranslator({
      locale,
      messages,
      namespace: "featurePageLanding"
    });
    return await buildFeaturePageLandingHead({
      landing: loaderData.landing,
      family,
      locale,
      title: t(`${family}.title`),
      description: t(`${family}.description`),
      editorialTitle: t("editorial")
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});